module.exports = __webpack_public_path__ + "static/img/cooperate.e1e31ec5.png";